<template>
  <div class="index w-100 p-0 ">
    <!--BANNER-->
    <div class="container-fluid p-0">
      <div class="section bg-secondary">
        <swiper :options="swiperOption" class="h-100 p-0 w-100 swiper-wrapper">
          <!-- 这部分放你要渲染的轮播内容 -->
          <swiper-slide v-for="(item, index) in banners" :key="index">
            <router-link :to="item.url">
              <div class="w-100 p-5 h-520p">
                <div class="position-absolute top  left right h-100">
                  <img class="img-fluid h-100" :src="item.src" alt="">
                </div>
                <div class="position-absolute top right  left h-100 d-flex align-items-center ">
                  <div class="container text-white d-flex align-items-center">
                    <div class="row w-100 d-flex align-items-center">
                      <div class="col-sm pl-sm-5 pt-sm-2">
                        <h1 class="pt-5 headline display-sm-4 m-0 text-shadow">{{ item.title }}</h1>
                        <h5 class=" headline font-weight-light m-0 text-shadow">{{ item.subtitle }}</h5>
                      </div>
                      <div class="col-sm-6 pt-5">
                        <p class="pt-3">
                          {{ item.content }}
                          <img class=" rounded" :src="item.contentImg" alt="">
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </swiper-slide>
          <!-- 标页码 - 小圆点 -->
          <!-- <div class="swiper-pagination" slot="pagination"></div> -->
          <!-- 滚动条 -->
          <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
        </swiper>
      </div>
    </div>
    <!--第一区-->
    <div class="container-fluidpl-0 pr-0 pt-3 pb-5">
      <div class=" section container ">
        <div class="p-sm-4 text-center">
          <router-link :to="'solution'">
            <h2 class="pt-4 text-dark ">卓越 <span class=" opacity-50">解决方案</span></h2>
          </router-link>
          <!-- <p class=" opacity-25">Solutions</p> -->
        </div>

        <div class="row px-2 px-md-0 text-center pb-md-5">
          <div class="col-4 col-md-3 col-xl-2  px-0" v-for="(item, index) in solutions" :key="index">
            <router-link :to="item.url" class="text-dark">
              <img :src="item.src" :alt="item.title">
              <h6>{{ item.title }}</h6>
            </router-link>
          </div>

        </div>
      </div>
    </div>
    <!--卓越 复制成功  绩效倍增™ 模型-->
    <div class="container-fluid text-justify " style=" background: #7188BA">
      <div class="container section p-0 px-3 position-relative">
        <img class=" d-none d-md-block" src="img/jx.svg" alt="">
        <img class=" d-block d-md-none" src="img/minijx.svg" alt="">
        <div class="position-absolute top left right">
          <div class="lanren">
            <ul>
              <li><img src="img/main5-pic1.svg"> </li>
              <li><img src="img/main5-pic2.svg"> </li>
              <li><img src="img/main5-pic3.svg"> </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--优势课程-->
    <div class="container-fluid bg-white pl-0 pr-0 pt-3 pb-5">
      <div class="container section ">
        <div class="p-sm-4 text-center">
          <router-link :to="'strategy'">
            <h2 class="pt-4 text-dark ">卓越 <span class=" opacity-50">优势课程</span></h2>
          </router-link>
          <!-- <p class=" opacity-25">Advantages Course</p> -->
        </div>
        <div class="row px-2 text-center">
          <div class="col-4 col-md-3 px-0 px-md-2" v-for="(item, index) in advantages" :key="index">
            <router-link :to="item.url" class=" text-dark">
              <img :src="item.src" :alt="item.title">
              <h6>{{ item.title }}</h6>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!--微课堂-->
    <!-- <div class="container-fluid text-justify p-sm-0">
      <div class="container pb-5 pt-4">

        <div class="p-sm-4 text-center">
          <router-link :to="'microLesson'">
            <h2 class="py-4 text-dark">卓越 <span class=" opacity-50">微课堂</span></h2>
          </router-link>
        
        </div>

        <div class="row px-1 ">
          
           
          <div class="col-6 col-md-3 pb-2 px-1">
            <router-link :to="'wei001'">
              <div class=" position-relative bg-light ">
                <img class=" rounded" src="img/video01.jpg" alt>
                <div class="player-bg position-absolute top bottom w-100 z-index-20 ">
                  <div class="phototitlebg px-3 pt-5 pb-3 position-absolute w-100 bottom text-white rounded-bottom">
                  
                    <small class="opacity-75">如何制定目标才能充分调动行为？</small>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-6 col-md-3 pb-2 px-1">
            <router-link :to="'wei002'">
              <div class=" position-relative bg-light ">
                <img class=" rounded" src="img/video02.jpg" alt>

                <div class="player-bg position-absolute top bottom w-100 z-index-20 ">
                  <div class="phototitlebg px-3 pt-5 pb-3 position-absolute w-100 bottom text-white rounded-bottom">
                  
                    <small class="opacity-75">思维导图让你有无穷大的创造力</small>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-md-3 pb-2 px-1">
            <router-link :to="'wei003'">
              <div class=" position-relative bg-light ">
                <img class=" rounded" src="img/video03.jpg" alt>

                <div class="player-bg position-absolute top bottom w-100 z-index-20 ">
                  <div class="phototitlebg px-3 pt-5 pb-3 position-absolute w-100 bottom text-white rounded-bottom">
                
                    <small class="opacity-75">经常用头脑风暴的你， 要会复式投票法</small>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-md-3 pb-2 px-1">
            <router-link :to="'wei004'">
              <div class=" position-relative bg-light ">
                <img class=" rounded" src="img/video04.jpg" alt>

                <div class="player-bg position-absolute top bottom w-100 z-index-20 ">
                  <div class="phototitlebg px-3 pt-5 pb-3 position-absolute w-100 bottom text-white rounded-bottom">
             
                    <small class="opacity-75">手把手教会你偏好矩阵法</small>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          
        </div>
        
        <p class="text-center py-4">
          <router-link :to="'microLesson'">
            <el-button type="button" round>查看更多</el-button>
          </router-link>
        </p>
      </div>
    </div> -->
    <!--微课堂 结束-->
    <!--顾问-->
    <!-- <div class="container-fluid  bg-white  pl-0 pr-0 pt-3 pb-5">
      <div class="container section ">
        <div class="p-sm-4 text-center">
          <h2 class="pt-4  ">卓越 <span class=" opacity-50">顾问</span></h2>
       
        </div>
        <div class="row grid lily">

          <div class="col-6 col-md-3 col-xl-2 p-2">
            <router-link :to="'ggw'">
              <figure class="effect-lily  rounded w-100">
                <img src="img/consultant002.jpg" alt="img12">
                <figcaption>
                  <div class="pb-4">
                    <h2 class="h3 pb-1 text-shadow">郭广文 </h2>
                    <p class="small">国务院国资委培训中心、国家财政部培训中心… </p>
                  </div>
                  
                </figcaption>
              </figure>
            </router-link>
          </div>

          <div class="col-6 col-md-3 col-xl-2 p-2">
            <router-link :to="'gwzhm'">
              <figure class="effect-lily  rounded w-100">
                <img src="img/consultant007.jpg" alt="img12">
                <figcaption>
                  <div class="pb-4">
                    <h2 class="h3 pb-1 text-shadow">赵浩明 </h2>
                    <p class="small">卓越体验顾问讲师；商业沙盘系列课程认证讲师 </p>
                  </div>
               
                </figcaption>
              </figure>
            </router-link>
          </div>

          <div class="col-6 col-md-3 col-xl-2 p-2">
            <router-link :to="'gwsh'">
              <figure class="effect-lily  rounded w-100">
                <img src="img/consultant001.jpg" alt="img12">
                <figcaption>
                  <div class="pb-4">
                    <h2 class="h3 pb-1 text-shadow">孙宏 </h2>
                    <p class="small">卓越体验资深顾问，企业管理咨询顾问，职业…</p>
                  </div>
                  
                </figcaption>
              </figure>
            </router-link>
          </div>

          <div class="col-6 col-md-3 col-xl-2 p-2">
            <router-link :to="'gwdm'">
              <figure class="effect-lily  rounded w-100">
                <img src="img/consultant003.jpg" alt="img12">
                <figcaption>
                  <div class="pb-4">
                    <h2 class="h3 pb-1 text-shadow">戴民 </h2>
                    <p class="small">卓越体验资深顾问/中国惠普特聘讲师/京东大学…</p>
                  </div>
                  
                </figcaption>
              </figure>
            </router-link>
          </div>

          <div class="col-6 col-md-3 col-xl-2 p-2">
            <router-link :to="'gwlys'">
              <figure class="effect-lily  rounded w-100">
                <img src="img/consultant004.jpg" alt="img12">
                <figcaption>
                  <div class="pb-4">
                    <h2 class="h3 pb-1 text-shadow">吕玉淑 </h2>
                    <p class="small dincondensedcregular">卓越体验顾问/ Everything DiSC认证讲师…</p>
                  </div>
                 
                </figcaption>
              </figure>
            </router-link>
          </div>

          <div class="col-6 col-md-3 col-xl-2 p-2">
            <router-link :to="'gwcp'">
              <figure class="effect-lily  rounded w-100">
                <img src="img/consultant012.jpg" alt="img12">
                <figcaption>
                  <div class="pb-4">
                    <h2 class="h3 pb-1 text-shadow">陈萍 </h2>
                    <p class="small dincondensedcregular">卓越体验顾问、同济大学法国路桥大学MBA认证培训师 </p>
                  </div>
                  
                </figcaption>
              </figure>
            </router-link>
          </div>

        </div>
        <p class="text-center py-4">
          <router-link :to="'consultant'">
            <el-button type="button" round>全部顾问</el-button>
          </router-link>
        </p>
      </div>
    </div> -->
    <!--顾问 结束-->
    <!--体验方式-->
    <!-- <div class="container-fluid  pl-0 pr-0 pt-3 pb-5">
      <div class="container section ">
        <div class="p-sm-4 text-center">
          <h2 class="pt-4  ">卓越 <span class=" opacity-50">体验方式</span></h2>
          <p class=" opacity-25">Experience mode</p>
        </div>
        <div class="row text-center px-2">
          <div class="col-4 col-md ">
            <img src="img/emode001.svg" alt="乐高">
            <h6>乐高</h6>
          </div>
          <div class="col-4 col-md">
            <img src="img/emode002.svg" alt="视觉引导">
            <h6>视觉引导</h6>
          </div>
          <div class="col-4 col-md">
            <img src="img/emode003.svg" alt="沙盘模拟">
            <h6>沙盘模拟</h6>
          </div>
          <div class="col-4 col-md">
            <img src="img/emode004.svg" alt="实战演练">
            <h6>实战演练</h6>
          </div>
          <div class="col-4 col-md">
            <img src="img/emode005.svg" alt="视频教学">
            <h6>视频教学</h6>
          </div>
          <div class="col-4 col-md">
            <img src="img/emode006.svg" alt="户外体验">
            <h6>户外体验</h6>
          </div>
          <div class="col-4 col-md">
            <img src="img/emode007.svg" alt="即兴喜剧">
            <h6>即兴喜剧</h6>
          </div>
          <div class="col-12 p-0 d-none d-md-block pb-md-4">
            <img src="img/emode.svg" alt="">
          </div>
        </div>
      </div>
    </div> -->
    <!--体验方式 结束-->

    <!--行业案例-->
    <div class="container-fluid  pl-0 pr-0   " style=" background:#202427; ">
      <div class="row grid text-center text-white p-0">
        <figure class="effect-ruby col-6 col-md-4 col-xl-2 p-0 m-0 overflow-h" v-for="(item, index) in cases"
          :key="index">
          <img class=" " :src="item.bgsrc" alt="img12" />
          <router-link :to="item.url">
            <figcaption>
              <div>
                <h2 class="h4 ">
                  <img class="w-50 m-auto" :src="item.iconImg" alt="">
                  <samp class="h2title ">{{ item.title }}</samp>
                </h2>
                <div class="p-0 small border-0 figureList">
                  <p v-for="(item, index) in item.content" :key="index">
                    <router-link :to="item.url">
                      <span class="text-white">{{ item.title }}</span>
                    </router-link>
                  </p>
                </div>
              </div>

            </figcaption>
          </router-link>
        </figure>

      </div>
    </div>

    <!--经典案例企业LOGO-->
    <div class="container-fluid  text-justify pl-0 pr-0 pt-3 pb-5" style=" background: #7188BA">
      <div class="container pt-4 pb-sm-4">
        <h2 class="pt-sm-4 text-center text-white pb-sm-4">卓越 <span class=" opacity-50">经典案例</span></h2>
        <div class="row px-3">
          <div class="col-6 col-md-4 col-lg-3 col-xl-2 pb-3 px-2" v-for="(item, index) in logos" :key="index">
            <img class="rounded" :src="item.src" alt>
          </div>
        </div>
      </div>
    </div>

    <!--开始联系我们-->
    <div class="gradient-overlay-half-primary-v1">
      <div class="bg-img-hero" style="background-image: url(img/bg2.png);">
        <div class="container pt-5 pb-5">
          <div class="row align-items-lg-center text-center text-lg-left space-2 px-2">
            <div class="col-lg">
              <h2 class="text-white">开始联系我们</h2>
              <p class="lead text-white mb-0">卓越体验与您一同“持续提升组织绩效”！</p>
            </div>

            <div class="col-lg-auto text-lg-right pt-4 pt-sm-0">
              <a class="btn btn-purple mb-2 mb-sm-0 mr-sm-2" href="#/contactUs">
                <!-- <span class=" ion-ios-telephone"></span> -->
                <span class="">18511937798</span> 了解更多 </a>
              <!-- <a class="btn btn-light mb-2 mb-sm-0" href="#">了解更多</a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--开始联系我们 结束-->
  </div>
</template>

<script>
import {
  Hooper,
  Slide,
  Progress as HooperProgress,
  Pagination as HooperPagination,
  Navigation as HooperNavigation
} from 'hooper';
export default {
  name: "index",
  data() {
    return {
      banners: [
        // {
        //   url: "ala",
        //   src: "img/010.jpg",
        // },
        // {
        //   url: "leadership08",
        //   src: "img/fxjjl.jpg",
        //   title: " ",
        //   subtitle: " ",
        //   content: " ",
        //   contentImg: ""
        // },
        // {
        //   url: "i3ku",
        //   src: "img/001.jpg",
        //   title: "组织绩效持续提升促动者",
        //   subtitle: "咨询定位组织课题，萃取提炼成功秘诀，教练辅导激发热情，行动学习促进绩效。",
        //   content: " ",
        //   contentImg: ""
        // },
        {
          url: "solution",
          src: "img/009.jpg",
          title: "教练引领式行动学习",
          subtitle: "引领高效学习、解决关键问题、实现绩效倍增",
          content: " ",
          contentImg: ""
        },
        // {
        //   url: "project01",
        //   src: "img/006.jpg",
        //   title: "卓越体验出版书籍",
        //   subtitle: "卓越体验历时10余年，总结了帮助1000名职场精英实现绩效倍增的六项修炼路径。",
        //   content: " ",
        //   contentImg: "img/book.jpg"
        // }
        // {
        //   url: "",
        //   src: "img/004.jpg",
        //   title: "洞查业务需求",
        //   subtitle: "可以成功复制绩效才能倍增！",
        //   content: " ",
        //   contentImg: ""
        // }
        // {
        //   url: "",
        //   src: "img/005.jpg",
        //   title: "洞查业务需求",
        //   subtitle: "可以成功复制绩效才能倍增！",
        //   content: " ",
        //   contentImg: ""
        // } 
      ],
      solutions: [
        {
          url: "solution01",
          src: "img/solution001.svg",
          title: "战略落地",
        },
        {
          url: "solution02",
          src: "img/solution002.svg",
          title: "领导力提升",
        },
        {
          url: "solution03",
          src: "img/solution003.svg",
          title: "行动学习",
        },
        {
          url: "solution04",
          src: "img/solution004.svg",
          title: "海外业务拓展",
        },
        {
          url: "solution05",
          src: "img/solution005.svg",
          title: "销售能力提升",
        },
        {
          url: "solution06",
          src: "img/solution006.svg",
          title: "培训系列服务",
        },
      ],
      advantages: [
        {
          url: "strategy04",
          src: "img/course001.svg",
          title: "战略落地工作坊",
        },
        {
          url: "strategy05",
          src: "img/course002.svg",
          title: "全面经营训练",
        },
        {
          url: "ability01",
          src: "img/course003.svg",
          title: "顾问式销售训练营",
        },
        {
          url: "leadership",
          src: "img/course004.svg",
          title: "领越™领导力",
        },
        {
          url: "leadership12",
          src: "img/course005.svg",
          title: "激发天赋能量 ©️",
        },
        {
          url: "strategy02",
          src: "img/course006.svg",
          title: "创新思维工作坊",
        },
        {
          url: "businessExpansion",
          src: "img/course007.svg",
          title: "海外业务规划",
        },
        {
          url: "individualAbility04",
          src: "img/course008.svg",
          title: "系统问题分析解决",
        },
      ],
      cases: [
        {
          url: "project01",
          bgsrc: "img/h001.jpg",
          title: "IT和通信技术",
          iconImg: "img/industry001.svg",
          content: [
            { title: "H公司领导力提升训练营", url: "project01", },
            { title: "HPE乐高认真玩", url: "project02", },
            { title: "联想服务部能力提升营", url: "project03", },
          ]
        },
        {
          url: "projectMedical01",
          bgsrc: "img/h002.jpg",
          title: "医院／医疗／医药",
          iconImg: "img/industry002.svg",
          content: [
            { title: "北京大学国际医院", url: "projectMedical01", },
            { title: "北京儿童医院苗圃计划", url: "projectMedical02", },
            { title: "东芝医疗中期战略规划营", url: "projectMedical03", },
          ]
        },
        {
          url: "projectWeb01",
          bgsrc: "img/h003.jpg",
          title: "互联网行业",
          iconImg: "img/industry003.svg",
          content: [
            { title: "J集团干部领导力训练营", url: "projectWeb01", },
            { title: "凤凰网像CEO一样思考案例", url: "projectWeb02", },
          ]
        },
        {
          url: "projectF01",
          bgsrc: "img/h004.jpg",
          title: "房地产",
          iconImg: "img/industry004.svg",
          content: [
            { title: "F地产公司“沃土计划”", url: "projectF01", },
            { title: "万科北京区域装修房大学", url: "projectF02", },
            { title: "华美地产猛虎训练营", url: "projectF03", },
          ]
        },
        {
          url: "projectF01",
          bgsrc: "img/h005.jpg",
          title: "汽车",
          iconImg: "img/industry005.svg",
          content: []
        },
        {
          url: "projectEdu01",
          bgsrc: "img/h006.jpg",
          title: "教育",
          iconImg: "img/industry006.svg",
          content: [
            { title: "北邮MBA“追求卓越”", url: "projectEdu01", },
            { title: "呼家楼中心小学冬令营", url: "projectEdu02", },
          ]
        },
      ],
      logos: [
        { src: "img/addlogo/logo001.svg" },
        { src: "img/addlogo/logo002.svg" },
        { src: "img/addlogo/logo003.svg" },
        { src: "img/addlogo/logo004.svg" },
        { src: "img/addlogo/logo005.svg" },
        { src: "img/addlogo/logo006.svg" },
        { src: "img/addlogo/logo007.svg" },
        { src: "img/addlogo/logo008.svg" },
        { src: "img/addlogo/logo009.svg" },
        { src: "img/addlogo/logo010.svg" },
        { src: "img/addlogo/logo011.svg" },
        { src: "img/addlogo/logo012.svg" }
      ],
      playsinline: true,
      hooperSettings: {
        centerMode: true,
        breakpoints: {
          800: {
            centerMode: false,
            itemsToSlide: 4,
            itemsToShow: 4
          },
          375: {
            itemsToSlide: 1,
            itemsToShow: 2,
            pagination: 'fraction'
          }
        }
      },
      playerOptions: {
        muted: true,
        controls: true,
        language: 'lang',
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速率
        sources: [{
          type: 'application/x-mpegURL',
          src: '4.m3u8' //视频流地址
        }],
        hls: true, //启用hls？
        fluid: true, //设置播放器为流体  宽度为外层盒子大小  ps：想设置width：100%找不到方法？这个就对了
        poster: "img/videodemo.jpg"
      },
      swiperOption: {
        speed: 600,
        grabCursor: true, //针会变成手掌形状
        autoplay: {
          delay: 5000, //自动切换的时间间隔，单位ms
          stopOnLastSlide: false, //当切换到最后一个slide时停止自动切换
          disableOnInteraction: false, //用户操作swiper之后，是否禁止autoplay。
          waitForTransition: true //等待过渡完毕。自动切换会在slide过渡完毕后才开始计时。
        },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets", //圆点 'fraction' //分式, 'progressbar'//进度, 'custom'//自定义
          dynamicMainBullets: 1, //动态分页器的主指示点的数量
          clickable: true //此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
        },
        on: {
          slideChange() {
            // vm.index = this.activeIndex + 1
          },
        },
      }
    }
  },
  components: {
    Hooper,
    Slide,
    // HooperProgress,
    HooperPagination,
    HooperNavigation
  },
  methods: {
    // listen event
    onPlayerPlay(player) {
      // console.log('player play!', player)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    onPlayerEnded(player) {
      // console.log('player ended!', player)
    },
    onPlayerLoadeddata(player) {
      // console.log('player Loadeddata!', player)
    },
    onPlayerWaiting(player) {
      // console.log('player Waiting!', player)
    },
    onPlayerPlaying(player) {
      // console.log('player Playing!', player)
    },
    onPlayerTimeupdate(player) {
      // console.log('player Timeupdate!', player.currentTime())
    },
    onPlayerCanplay(player) {
      // console.log('player Canplay!', player)
    },
    onPlayerCanplaythrough(player) {
      // console.log('player Canplaythrough!', player)
    },
    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log(playerCurrentState)
    },
    // player is ready
    playerReadied(player) {
      // console.log('example 01: the player is readied', player)
    }
  }
}
</script>

<style scoped lang="scss">
.index {
  margin-top: 0px;

  .swiper-pagination-bullet-active {
    background: rgba(255, 255, 255, 0.6);
  }

  .dhdh {
    color: #008fd1;
    font-weight: 700;
  }
}

.figureList {
  margin-top: 30px;

  p {
    padding: 0 !important;
    border: 0 !important;
    margin: 0 !important;
  }
}

@media (min-width:767.98px) {
  .index {
    .hooper {
      /* margin: 0 -8px */
    }
  }
}
</style>